import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import { AppActions } from '@/app/app.keys';
import store from '@/store';

export function clearGlobals(to, from, next) {
  if (store.state.errorsState.keepOnce) {
    store.dispatch(TolErrorsActions.SetKeepOnce, false);
  } else {
    store.dispatch(TolErrorsActions.ClearAll);
  }

  store.dispatch(AppActions.SetPageTitle, '');
  next();
}
